import { render } from "./DetailsProducts.vue?vue&type=template&id=5b5d7c5b&scoped=true"
import script from "./DetailsProducts.vue?vue&type=script&lang=js"
export * from "./DetailsProducts.vue?vue&type=script&lang=js"

import "./DetailsProducts.vue?vue&type=style&index=0&id=5b5d7c5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5d7c5b"]])

export default __exports__